<p>Ground Elevation Above Sea Level: <strong>{{ data.altitude | length : conversion : 2 : true }}</strong></p>
<p><strong>{{ data.latitude.toFixed(6) }}, {{ data.longitude.toFixed(6) }}</strong><em> (lat, lon)</em></p>